export default {
    default: [
        {
            id: 'esker',
            title: window.i18n.__('Courrier'),
            description: window.i18n.__('Envoi de documents par courrier'),
            unit: window.i18n.__('crédits'),
        },
        {
            id: 'yousign',
            title: window.i18n.__('Signature électronique'),
            description: window.i18n.__('Signature électronique des documents'),
            unit: window.i18n.__('crédits'),
        },
        {
            id: 'email_marketing',
            title: window.i18n.__('Email'),
            description: window.i18n.__("Envoi d'email uniquement"),
            unit: window.i18n.__('crédits'),
        },
        {
            id: 'sms_marketing',
            title: window.i18n.__('SMS'),
            description: window.i18n.__('Envoi de sms marketing'),
            unit: window.i18n.__('crédits'),
        },
    ],
    v5: {
        default: [
            {
                id: 'esker',
                title: window.i18n.__('Courrier'),
                description: window.i18n.__('Envoi de documents par courrier'),
                unit: window.i18n.__('crédits'),
                icon: 'nav-mail',
            },
            {
                id: 'yousign',
                title: window.i18n.__('Signature électronique'),
                description: window.i18n.__('Signature électronique des documents'),
                unit: window.i18n.__('crédits'),
                icon: 'nav-redactor',
            },
        ],
        marketing: [
            {
                id: 'marketing_emailing',
                title: window.i18n.__('Email'),
                description: window.i18n.__("Envoi d'email uniquement"),
                unit: window.i18n.__('crédits'),
                icon: 'email',
            },
            {
                id: 'marketing_sms',
                title: window.i18n.__('SMS'),
                description: window.i18n.__('Envoi de sms marketing'),
                unit: window.i18n.__('crédits'),
                icon: 'phone',
            },
            {
                id: 'marketing_transactional',
                title: window.i18n.__('Email SMTP'),
                description: window.i18n.__("Envoi d'email marketing"),
                unit: window.i18n.__('crédits'),
                icon: 'email',
            },
        ],
        limits: [
            {
                id: 'document_invoices',
                title: window.i18n.__('Facturation'),
                description: window.i18n.__('Création de facture'),
                unit: window.i18n.__('par mois'),
            },
            {
                id: 'catalog_items',
                title: window.i18n.__('Catalogue'),
                description: window.i18n.__('Produit et service'),
            },
            {
                id: 'file_storage',
                title: window.i18n.__('Fichier'),
                description: window.i18n.__('Stockage'),
                unit: window.i18n.__('Mo'),
            },
            {
                id: 'bank_account_reconciliations',
                title: window.i18n.__('Banque'),
                description: window.i18n.__('Synchronisation bancaire'),
                unit: window.i18n.__('banque'),
                unitPluralized: window.i18n.__('banques'),
            },
            {
                id: 'recurring',
                title: window.i18n.__('Abonnement'),
                description: window.i18n.__('Gestion des abonnements récurents'),
            },
        ],
    },
};
